<template>
  <main class="main-login">
    <div class="image-container">
      <!-- <img src="../assets/images/Logo.png" alt="Rds" />-->
    </div>

    <div class="box-login">
      <div class="signin" ref="googleButton" v-on:tap="googleLogin">
        <!-- <i class="rds-icon rds-icon-google_icon"></i> -->
        <div class="icon-container">
          <img src="../assets/rds-life-fonticons/google_icon1.svg" alt />
        </div>
        <span>Accedi</span>
      </div>
    </div>
  </main>
</template>
<script>
import RdsUser from '../models/rdsUser.model';
import userService from '../services/User.service';
import gApiWrapper from '../services/GapiWrapper.service';
import cookieService from '../services/Cookies.service';
console.log('test');

let AWS = window.AWS;
export default {
  name: 'login',
  data() {
    return {
      googleSignInParams: {
        client_id:
          '302015321251-ljludv1la4u9ud5mc9uatr0ergamg198.apps.googleusercontent.com'
      }
    };
  },
  methods: {
    onGoogleSignInSuccess(googleUser) {
      // `googleUser` is the GoogleUser object that represents the just-signed-in user.
      // See https://developers.google.com/identity/sign-in/web/reference#users
      const profile = googleUser.getBasicProfile(); // etc etc
      console.log(profile);
      AWS.config.region = 'eu-west-1';
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: 'eu-west-1:fdd5e25c-da30-4878-aa66-7384767fade1',
        Logins: {
          'accounts.google.com': googleUser.getAuthResponse().id_token
        }
      });
      AWS.config.credentials.get(data => {
        onAwsGetCredentialSuccess(data, profile).then(() => {
          this.$router.push('/');
        });
      });
    },
    googleLogin() {
      if (window.cordova) {
        window.plugins.googleplus.login(
          getNativeLoginConfig(),
          onNativeLoginSuccess,
          function(msg) {
            alert('error: ' + msg);
          }
        );
      }
    },
    onAndroidGoogleSignInSuccess(googleToken, profile) {
      AWS.config.region = 'eu-west-1';
      AWS.config.credentials = new AWS.CognitoIdentityCredentials({
        IdentityPoolId: 'eu-west-1:fdd5e25c-da30-4878-aa66-7384767fade1',
        Logins: {
          'accounts.google.com': googleToken
        }
      });
      AWS.config.credentials.get(data => {
        onAwsGetCredentialSuccess(data, profile).then(() => {
          this.$router.push('/');
        });
      });
    },
    onGoogleSignInError(error) {
      console.log('OH NOES', error);
    }
  },
  mounted() {
    let button = this.$refs.googleButton;
    console.log('mounted');
    console.log('window.cordova', window.cordova);
    if (!window.cordova) {
      gApiWrapper.init().then(() => {
        gApiWrapper.attachClickHandler(
          button,
          {},
          this.onGoogleSignInSuccess,
          this.onGoogleSignInError
        );
      });
    } else {
      console.log('try silent login');
      silentLogin();
    }
  },
  created() {
    setVueComponent(this);
  }
};
let _vueComponent = null;
let pluginsResolvers = [];

function refreshGetPlugins() {
  if (window.plugins) {
    getPlugins().then(console.log);
  } else {
    setTimeout(() => {
      refreshGetPlugins();
    }, 500);
  }
}

function silentLogin() {
  console.log(window.skipAutoLogin);
  if (!window.skipAutoLogin) {
    getPlugins().then(plugins => {
      window.plugins.googleplus.trySilentLogin(
        getNativeLoginConfig(),
        onNativeLoginSuccess,
        function(msg) {
          navigator.splashscreen.hide();
          console.log('error: ' + msg);
        }
      );
    });
    refreshGetPlugins();
  } else {
    window.skipAutoLogin = false;
  }
}

function getPlugins() {
  return new Promise((resolve, reject) => {
    if (!!!window.plugins) {
      pluginsResolvers.push(resolve);
    } else {
      for (let i = 0; i < pluginsResolvers.length; i++) {
        pluginsResolvers[i](window.plugins);
      }
      pluginsResolvers = [];
      resolve(window.plugins);
    }
  });
}

function setVueComponent(vueComponent) {
  _vueComponent = vueComponent;
}
function setGoogleObject(token, email, name, image, accessToken) {
  console.log(token, email, name, image);
  gApiWrapper.androidLogin = true;

  let profile = {
    getEmail: function() {
      return email;
    },
    getName: function() {
      return name;
    },
    getImageUrl: function() {
      return image;
    },
    email: email,
    name: name,
    image: image,
    token: token
  };
  gApiWrapper.currentUser = profile;
  gApiWrapper.token = accessToken; // token;
  cookieService.setCookie('androidLogin', true);
  cookieService.setCookie('loginToken', accessToken);
  _vueComponent.onAndroidGoogleSignInSuccess(token, profile);
}
window.setGoogleObject = setGoogleObject;

function onAwsGetCredentialSuccess(data, profile) {
  return new Promise((resolve, reject) => {
    // Credentials will be available when this function is called.
    let accessKeyId = AWS.config.credentials.accessKeyId;
    let secretAccessKey = AWS.config.credentials.secretAccessKey;
    let sessionToken = AWS.config.credentials.sessionToken;
    let identityId = AWS.config.credentials.identityId;
    console.log(accessKeyId, secretAccessKey, sessionToken, identityId);
    let user = new RdsUser({
      id: profile.getEmail(),
      name: profile.getName(),
      photos: [profile.getImageUrl()]
    });
    userService.login(user).then(u => {
      resolve(u);
    });
  });
}

const NATIVE_LOGIN_CONFIG = {
  scopes:
    'https://www.googleapis.com/auth/calendar https://www.googleapis.com/auth/calendar.readonly https://www.googleapis.com/auth/admin.directory.resource.calendar.readonly', // optional, space-separated list of scopes, If not included or empty, defaults to `profile` and `email`.
  webClientId:
    '302015321251-ljludv1la4u9ud5mc9uatr0ergamg198.apps.googleusercontent.com', // optional clientId of your Web application from Credentials settings of your project - On Android, this MUST be included to get an idToken. On iOS, it is not required.
  offline: false // optional, but requires the webClientId - if set to true the plugin will also return a serverAuthCode, which can be used to grant offline access to a non-Google server
};

function getNativeLoginConfig() {
  // if (window.cordova && window.device.platform !== 'iOS') {
  //   NATIVE_LOGIN_CONFIG.scopes =
  //     'https://www.googleapis.com/auth/admin.directory.resource.calendar.readonly';
  // }
  console.log(NATIVE_LOGIN_CONFIG);

  return NATIVE_LOGIN_CONFIG;
}

function onNativeLoginSuccess(obj) {
  console.log('onNativeLoginSuccess');
  console.log(obj);
  setGoogleObject(
    obj.idToken,
    obj.email,
    obj.displayName,
    obj.imageUrl,
    obj.accessToken
  );
  setTimeout(() => {
    navigator.splashscreen.hide();
  }, 500);
}
</script>
<style lang="scss" scoped>
main {
  display: flex;
  flex-direction: column;
  & > * {
    margin: 0 50px 75px 50px;
  }
  .image-container {
    //margin: 67%;
    margin: auto;
  }
  /*background-image: linear-gradient(
    to top,
    #f2f2f2 0%,
    rgba(204, 204, 204, 0.73) 33%,
    rgba(168, 168, 168, 0.17) 100%
  );*/
  background-image: url('../assets/images/Loginpage1x.jpg');
  background-size: cover;
  background-position: center;
  .signin {
    background-color: $main-red;
    color: white;
    padding: 18px 23px;
    border-radius: $default-border-radius;
    display: flex;
    i {
      position: absolute;
    }
    span {
      margin: auto;
      letter-spacing: 1px;
    }
  }
}
</style>
